// extracted by mini-css-extract-plugin
export default {"tooltipContainer":"C5qgVGOG7tGDtwWqfV7Q","flex":"CAjCAb6w8q6iD_xt9l1j","spacing":"EmbmC2TSCBZXbsQK3dF1","lineBreak":"gXJCNXZw2tNmxpPNaE79"};